const PARTS = [
  {
    n: "01",
    title: "Frame",
    one: "The way you walk into the call.",
    body: "Not a script. A position. Most guys lose the sale before they say a word because their frame is \"please buy from me.\" We fix that first. Frame is the only thing in sales that scales.",
  },
  {
    n: "02",
    title: "Reps",
    one: "Drilling without burning leads.",
    body: "The AI trainer runs you through every objection, every stall, every awkward moment until your tone is automatic. You walk onto a real call already warm. Most guys burn 50 real leads learning what you'll learn in a week of reps.",
  },
  {
    n: "03",
    title: "Network",
    one: "The private room.",
    body: "The standard stays alive every day. Wins get posted. Losses get diagnosed. You don't need motivation, you need to be in a room where flat is the floor. That's what the WhatsApp does.",
  },
  {
    n: "04",
    title: "Placement",
    one: "The door to real offers, when you're ready.",
    body: "This is the part nobody else does. Once your frame is locked and your reps are in, we put you in front of real paid setter and closer offers. Not a job board. A direct line. You still have to pass the offer's bar — that part is on you, and most people aren't ready overnight. But when you are, the door is already open.",
  },
];

export default function GateMethod() {
  return (
    <section id="method" className="access-section">
      <div className="access-container">
        <div className="max-w-3xl">
          <span className="mono-label mono-label-gold">The method</span>
          <h2 className="h-section mt-6">The Gate Method. Four parts. <span>Run in order.</span></h2>
        </div>

        <div className="mt-16 md:mt-20 grid md:grid-cols-2 border-t border-l" style={{ borderColor: "var(--rule)" }}>
          {PARTS.map((p) => (
            <article
              key={p.n}
              className="relative p-10 md:p-12 border-r border-b group transition-colors duration-300"
              style={{ borderColor: "var(--rule)" }}
            >
              <span className="absolute left-0 top-0 bottom-0 w-[2px] bg-gold scale-y-0 origin-top group-hover:scale-y-100 transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)]" />
              <div className="flex items-baseline justify-between mb-8">
                <span className="font-mono text-[11px] tracking-[0.22em] text-gold">{p.n}</span>
                <span className="font-mono text-[10px] tracking-[0.22em] uppercase text-mute">Part {p.n}</span>
              </div>
              <h3 className="h-card text-bone">{p.title}</h3>
              <p className="mt-4 font-display italic text-gold text-lg" style={{ fontVariationSettings: '"opsz" 96, "SOFT" 100', fontWeight: 350 }}>{p.one}</p>
              <p className="mt-6 text-dim leading-[1.7] text-[15.5px]">{p.body}</p>
            </article>
          ))}
        </div>

        <p className="mt-12 max-w-2xl text-dim body-lg">
          The four parts run in order. You don't drill objections in week one. You don't go for placement before your frame holds. Each part unlocks the next. That's the method.
        </p>
      </div>
    </section>
  );
}
